var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTracks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0475A768-F8EF-4739-99DA-5836B8A00BF7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-19.878146%",
    y1: "-27.0413204%",
    x2: "47.8712491%",
    y2: "98.7107052%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86C8DF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A6A7F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "143.06116%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A6A7F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86C8DF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Managers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-405.000000, -236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NoTracks",
    transform: "translate(400.000000, 231.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10-Copy-2",
    fill: "url(#linearGradient-1)",
    x: 10.3518519,
    y: 10.3518519,
    width: 65.2962963,
    height: 65.2962963,
    rx: 16.0000002
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.071658, 43.196878) rotate(25.000000) translate(-43.071658, -43.196878) translate(11.071658, 11.196878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10",
    fill: "url(#linearGradient-2)",
    x: 0,
    y: 0,
    width: 63.7037037,
    height: 63.7037037,
    rx: 16.0000002
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10-Copy",
    fill: "#FFFFFF",
    x: 3.98148148,
    y: 3.98148148,
    width: 55.7407407,
    height: 55.7407407,
    rx: 11.2000002
  })))), /*#__PURE__*/React.createElement("g", {
    id: "round-format_list_bulleted-24px",
    transform: "translate(27.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333333,14 C4.22666667,14 3.33333333,14.8933333 3.33333333,16 C3.33333333,17.1066667 4.22666667,18 5.33333333,18 C6.44,18 7.33333333,17.1066667 7.33333333,16 C7.33333333,14.8933333 6.44,14 5.33333333,14 Z M5.33333333,6 C4.22666667,6 3.33333333,6.89333333 3.33333333,8 C3.33333333,9.10666667 4.22666667,10 5.33333333,10 C6.44,10 7.33333333,9.10666667 7.33333333,8 C7.33333333,6.89333333 6.44,6 5.33333333,6 Z M5.33333333,22 C4.22666667,22 3.33333333,22.9066667 3.33333333,24 C3.33333333,25.0933333 4.24,26 5.33333333,26 C6.42666667,26 7.33333333,25.0933333 7.33333333,24 C7.33333333,22.9066667 6.44,22 5.33333333,22 Z M10.6666667,25.3333333 L26.6666667,25.3333333 C27.4,25.3333333 28,24.7333333 28,24 C28,23.2666667 27.4,22.6666667 26.6666667,22.6666667 L10.6666667,22.6666667 C9.93333333,22.6666667 9.33333333,23.2666667 9.33333333,24 C9.33333333,24.7333333 9.93333333,25.3333333 10.6666667,25.3333333 Z M10.6666667,17.3333333 L26.6666667,17.3333333 C27.4,17.3333333 28,16.7333333 28,16 C28,15.2666667 27.4,14.6666667 26.6666667,14.6666667 L10.6666667,14.6666667 C9.93333333,14.6666667 9.33333333,15.2666667 9.33333333,16 C9.33333333,16.7333333 9.93333333,17.3333333 10.6666667,17.3333333 Z M9.33333333,8 C9.33333333,8.73333333 9.93333333,9.33333333 10.6666667,9.33333333 L26.6666667,9.33333333 C27.4,9.33333333 28,8.73333333 28,8 C28,7.26666667 27.4,6.66666667 26.6666667,6.66666667 L10.6666667,6.66666667 C9.93333333,6.66666667 9.33333333,7.26666667 9.33333333,8 Z",
    id: "Shape",
    fill: "#2A6A7F",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTracks);
export default __webpack_public_path__ + "static/media/no_tracks.4ae5674efe206eeb803d427888d435b6.svg";
export { ForwardRef as ReactComponent };